import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { DashboardShell } from "@/components/dashboard/DashboardShell";
import { adminConfig } from "@/config/admin";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CRMErrorBoundary } from "@/components/followup/CRMErrorBoundary";
import { Skeleton } from "@/components/ui/skeleton";

const Overview = lazy(() => import("./overview"));
const Community = lazy(() => import("./community"));
const Donors = lazy(() => import("./donors"));
const Finance = lazy(() => import("./finance"));
const HaafPayments = lazy(() => import("./haaf-payments"));
const Manage = lazy(() => import("./settings"));
const AdminFollowUpDashboard = lazy(
  () => import("@/pages/dashboard/AdminFollowUpDashboard"),
);

function PageSkeleton() {
  return (
    <div className="p-4 space-y-3">
      <Skeleton className="h-10 w-48" />
      <Skeleton className="h-9 w-full rounded-md" />
      <Skeleton className="h-64 rounded-xl" />
    </div>
  );
}

export default function AdminDashboard() {
  return (
    <ProtectedRoute allowedRoles={["admin"]}>
      <DashboardShell navItems={adminConfig.sidebarNav}>
        <Suspense fallback={<PageSkeleton />}>
          <Routes>
            <Route path="overview" element={<Overview />} />
            <Route path="community" element={<Community />} />
            <Route path="donors" element={<Donors />} />
            <Route path="finance" element={<Finance />} />
            <Route path="haaf-payments/*" element={<HaafPayments />} />
            <Route
              path="follow-ups"
              element={
                <CRMErrorBoundary>
                  <AdminFollowUpDashboard />
                </CRMErrorBoundary>
              }
            />
            <Route path="manage" element={<Manage />} />
            <Route path="*" element={<Navigate to="overview" replace />} />
          </Routes>
        </Suspense>
      </DashboardShell>
    </ProtectedRoute>
  );
}
